import { render, staticRenderFns } from "./BdFeedback.vue?vue&type=template&id=a18fef70&"
import script from "./BdFeedback.vue?vue&type=script&lang=js&"
export * from "./BdFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports